import React from 'react';
import {X2AgeCategory} from '../../../domain';
import {TooltipBreadcrumb} from '../../../lib/components';
import {routes} from '../../../pages/Routes';

export class X2AgeCategoryBreadcrumbs extends React.Component<{ ageCategory: X2AgeCategory }> {
  render() {
    const {ageCategory} = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="breadcrumb">
            <TooltipBreadcrumb tooltip="Languages"
                               label="Languages"
                               route={routes.X1LanguageList}/>

            <TooltipBreadcrumb tooltip="Language"
                               label={ageCategory!.Language!.Name}
                               route={routes.x1language(ageCategory!.LanguageId)}/>

            <TooltipBreadcrumb tooltip="Age Category"
                               label={ageCategory!.Name}
                               active/>
          </div>
        </div>
      </div>
    );
  }
}
